import React, { useMemo } from 'react';
import { ZonedDateTime } from '@js-joda/core';
import { EventCard, EventCardProps } from '@opendoor/cinderblocks/platform/EventCard';

import { MONTH_ONLY_FORMAT, TIME_WITH_TZ_FORMAT, TIME_ONLY_FORMAT } from 'shared/helpers/datetime';
import { isOpendoorAppEvoWebView } from 'shared/helpers/globals';

export type IScheduleCardProps = Omit<EventCardProps, 'chipOrIconProps'> & {
  /** Time for the Schedule Event. */
  scheduleTime: ZonedDateTime;
  /** Duration for the Schedule Event in minutes. */
  eventDuration: number;
  /** Whether theres multiple events */
  multiEvent?: boolean;
};

/** TODO: Add documentation */
export const ScheduledEventCard: React.FC<IScheduleCardProps> = ({
  scheduleTime,
  eventDuration,
  multiEvent = false,
  ...eventCardProps
}) => {
  const scheduleTimeDisplay = useMemo(() => {
    const timeFormat = isOpendoorAppEvoWebView ? TIME_ONLY_FORMAT : TIME_WITH_TZ_FORMAT;
    if (multiEvent) {
      return scheduleTime.format(timeFormat);
    }
    return `${scheduleTime.format(timeFormat)} (${eventDuration} min)`;
  }, [scheduleTime, eventDuration, multiEvent]);

  return (
    <EventCard
      {...eventCardProps}
      chipOrIconProps={{
        firstLine: scheduleTime.format(MONTH_ONLY_FORMAT).toUpperCase(),
        secondLine: scheduleTime.dayOfMonth().toString(),
      }}
      subtitle={scheduleTimeDisplay}
    />
  );
};
